import type { WeatherSnapshot, WorkoutSnapshot } from "../types/garage";

export const weatherSnapshot: WeatherSnapshot = {
  condition: "Partly Cloudy",
  highF: 86,
  windMph: 15,
  precipitationChancePercent: 12
};

export const workoutSnapshot: WorkoutSnapshot = {
  title: "Aerobic Strength Builder",
  plannedDurationMinutes: 125,
  intensity: "moderate",
  rideProfile: "gravel"
};
